exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".reveal section img{background:unset;border:unset;box-shadow:unset}.reveal table td{padding-top:0;padding-bottom:0}.reveal p{font-size:.7em}.reveal h3,.reveal h4,.reveal h5{color:#000}.reveal pre,.reveal pre code{max-height:560px}.row{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.column,.row{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-direction:normal}.column{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}.small-img{height:100px;width:100px}.medium-img{height:200px;width:200px}.centered{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.fill{width:100%;height:100%}.obscure{background:#000;opacity:.5}.inline>*{display:inline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader?{"plugins":[null,null]}!./~/sass-loader/lib/loader.js!./src/app/slide-deck/slide-deck.component.scss
// module id = 136
// module chunks = 1